function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGestionCofidoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1651.5732 1303.4",
    height: 1303.4,
    width: 1651.5732,
    stroke: "currentColor",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1303.4)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "none",
      strokeWidth: 600,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 12296.8,90 H 90 v 1468.47 h 12206.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "none",
      strokeWidth: 600,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 2309.13,6136.42 V 2561.1 H 840.684 v 3575.32 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "none",
      strokeWidth: 600,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 5409.79,8168.31 V 2561.1 H 3941.33 v 5607.21 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "none",
      strokeWidth: 600,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 11546.1,9685.46 V 2561.1 h -1468.4 v 7124.36 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "none",
      strokeWidth: 600,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 8445.49,7070.04 V 2561.1 H 6977.03 v 4508.94 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestionCofidoc);
export default __webpack_public_path__ + "static/media/gestion-cofidoc.8835586e25121495e78f348e56966cc2.svg";
export { ForwardRef as ReactComponent };